import * as actionTypes from './actions';
export const initialState = {
    chartData: {},
    isSplit: false,
    showSharePrice: false,
    dataType: ['investor-type'],
    timeRange: { value: '6Months', label: 'Last 6 months' },
    isNumber: true,
    isPercentage: false,
    loading: false
};
const EngagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.setIsNumber:
            return {
                ...state,
                isNumber: action.isNumber
            };
        case actionTypes.setDataType:
            return {
                ...state,
                dataType: action.dataType
            };
        case actionTypes.setChartData:
            return {
                ...state,
                chartData: action.chartData
            };
        case actionTypes.setIsPercentage:
            return {
                ...state,
                isPercentage: action.isPercentage
            };
        case actionTypes.setIsSplit:
            return {
                ...state,
                isSplit: action.isSplit
            };
        case actionTypes.setShowSharePrice:
            return {
                ...state,
                showSharePrice: action.showSharePrice
            };
        case actionTypes.setLoading:
            return {
                ...state,
                loading: action.loading
            };
        case actionTypes.setTimeRange:
            return {
                ...state,
                timeRange: action.timeRange
            };
        case actionTypes.setAllEngagementValue:
            return {
                ...state,
                timeRange: action.engagementValue?.timeRange,
                loading: action.engagementValue?.loading,
                showSharePrice: action.engagementValue?.showSharePrice,
                isSplit: action.engagementValue?.isSplit,
                dataType: action.engagementValue?.dataType,
                isNumber: action.engagementValue?.isNumber,
                isPercentage: action.engagementValue?.isPercentage
            };
        default:
            return state;
    }
};
export default EngagementReducer;
